export function toggleItem (itemId, list) {
  list.find(item => {
    if (item.id === itemId) {
      item.isActive = !item.isActive
    }
  })

  return !!(list.findIndex(item => item.isActive) + 1)
}

export function toggleAll (table, list) {
  table.allActive = !table.allActive

  list.forEach(item => {
    item.isActive = table.allActive
  })

  return table.allActive
}

export function deleteToggleItems (list) {
  return list.filter(item => !item.isActive)
}
